const TmpL015 = (page) => {
  const media = [];
  const images = [];
  const eMentors = [];
  const modifiedPage = {
    ...page
  };

  const image = {
    size: '900px X 900px',
    ...page.content.core.media,
    page: page.id,
    src: page.label.toLowerCase().replaceAll('-', '_') + '.jpg'
  };
  // add the media object to the media array
  media.push(image);
  images.push(image);

  modifiedPage.content.core.media = image;

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Inject page.id into each focus point if present
  if (page.content && Array.isArray(page.content.focus_points)) {
    page.content.focus_points.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: [],
    eMentor: eMentors,
    focusPoints: page.content.focus_points || []
  };

  return { modifiedPage, metadata };
};

export default TmpL015;
